import React from 'react';

const PageNotFound: React.FunctionComponent = () => <h1>Oops! Page not found.</h1>;

export default PageNotFound;
